module.exports = __webpack_public_path__ + "static/media/16_MBTA - Boston.4d8feea0.jpg";